import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { GridDataResult, RowClassArgs, SelectionEvent } from '@progress/kendo-angular-grid';
import { EMDMICONS } from 'src/app/features/common/constants/icon-pack.constant';
import { commonService } from 'src/app/services/common.service';
import { PMService } from '../../../service/pm.service';
import { PMBuild } from '../../../models/pm-build.model';
import { ColumnConfig, FieldValidation, ImportData } from 'src/app/features/common/models/column-config.model';
import { ExportService } from 'src/app/services/export.service';
import { isDate } from 'moment';
import { DateTransformPipe } from 'src/app/pipes/date-transform.pipe';
import { pipe } from 'rxjs';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';

@Component({
  selector: 'app-acd-pm-build',
  templateUrl: './acd-pm-build.component.html',
  styleUrl: './acd-pm-build.component.scss'
})
export class AcdPmBuildComponent {

  defineView = false;
  searchView = false;
  buildView = true;
  summaryView = true;
  isServiceTypeShow = true;
  HeaderDropdown = ["Header", "Route"];
  suppressedDropdown = ["", "Supressed", "Seperate WO"];
  pmHeaderMessage = '';
  mwoErrorList: any[] = [];
  localAddRoute = 1;
  SelectedSuppresion = Object.freeze({
    '': '',
    1: 'selected1',
    2: 'selected2'
  });

  mwoGridColumn: ColumnConfig[] = [
    { field: 'mwoNumber', title: 'MWO', width: 120, isSearchProperty: true },
    { field: 'mwoNumber', title: '', width: 120, isSearchProperty: true },
    { field: 'cridList', title: '', width: 280, isSearchProperty: true },
  ];

  popupGridColumn: ColumnConfig[] = [
    { field: 'type', title: 'Service Type', width: 120, isSearchProperty: true },
    { field: 'description', title: 'Description', width: 280, isSearchProperty: true },
  ];

  equipmentSelectColumn: ColumnConfig[] = [
    { field: 'equipTag', title: 'Equipment Tag Number', width: 120, isSearchProperty: true },
    { field: 'equipDesc', title: 'Equipment Tag Description', width: 250, isSearchProperty: true },
    { field: 'equipSubClass', title: 'Equipment Sub Class', width: 120, isSearchProperty: false },
  ];

  minorServiceTypeSelectColumn: ColumnConfig[] = [
    { field: 'srvt', title: 'Minor Service Type', width: 150, isSearchProperty: true },
    { field: 'srvd', title: 'Service Days', width: 150, isSearchProperty: true },
  ];

  ServiceTypeSelectColumn: ColumnConfig[] = [
    { field: 'ky', title: 'Service Type', width: 150, isSearchProperty: true },
    { field: 'dl01', title: 'Description', width: 150, isSearchProperty: true },
  ];

  mwoSelectColumn: ColumnConfig[] = [
    { field: 'mwoNumber', title: 'MWO Number', width: 100, isSearchProperty: true },
    { field: 'mctMwoNumber', title: 'MCTMWO', width: 100, isSearchProperty: true },
    { field: 'equipTagNumber', title: 'Equipment Tag Number', width: 120, isSearchProperty: true },
    { field: 'mwoProblemDescription', title: 'MWO Problem Description', width: 150, isSearchProperty: true },
    { field: 'performanceStandard', title: 'Performance Standard', width: 120, isSearchProperty: true },
  ];

  frequencyIndicatorSelectColumn: ColumnConfig[] = [
    { field: 'frequencyIndicator', title: 'Frequency Indicator', width: 150, isSearchProperty: true },
    { field: 'description', title: 'Description', width: 150, isSearchProperty: true },
  ];

  fieldValidationInput!: FieldValidation[];
  serviceTypeList: any[] = [];

  crNo = 0;
  @Input() set setCRNo(crNo: number) {
    if (crNo > 0 && this.crNo != crNo) {
      this.crNo = crNo;
      this.getPMBuild();
    }
  }

  isUserHaveAccess: boolean = true;
  @Input() set setCrDetails(crDetails: any) {
    let admin= sessionStorage.getItem('admin');
    let specialist = sessionStorage.getItem('specialist');
    if (specialist != 'true' || admin != 'true') {
      if (crDetails) {
        this.crDetails = crDetails;
        this.isUserHaveAccess = crDetails.isUserCanAccessRequest ?? false;
        this.commonService.styleApplyForNonAccessUser(this.renderer, this.isUserHaveAccess, ['pmBuildGrid1', 'pmBuildGrid2'], ['exportPMBuild', 'backStepNavigation'], ['exportPMBuild', 'clearAllInBuild', 'backStepNavigation']);
      } else {
        this.isUserHaveAccess = false;
      }
    }
  }


  mwoErrorTextList: any[] = [];

  @Output() stepNavigateTo = new EventEmitter<string>();
  @HostListener('document:keydown.escape', ['$event1']) handleEscapeEvent(event: KeyboardEvent) {
    this.closeActionPopup(false);
  }

  dropDownList = ["No change", "Add", "Delete"];
  multiFlagOptions = [" ", "1"];

  pmViewData: PMBuild[] = [];
  pmOGViewData: PMBuild[] = [];
  pmExportViewData: any[] = [];

  equipmentRouteViewData: any[] = [];
  equipmentRouteExportViewData: any[] = [];
  equipmentRouteViewData_Filtered: any[] = [];
  equipmentRouteOGData: any[] = [];

  associationViewData: any[] = [];
  associationViewData_Filtered: any[] = [];
  associationOGData: any[] = [];

  expandedState = false;
  crDetails: any = null;
  popupDataList!: GridDataResult;

  skip = 0;
  pageSize = 5;
  searchText: string = "";
  equipmentRouteActionName = 'No change';
  lastEquipmentRouteActionName = 'No change';
  actionApplied = false;
  minorserviceequipTag: string = '';
  minorserviceserviceType: string = '';
  parentAssocationAction: string = 'Add';

  public headerSelectedIds: Set<number> = new Set<number>();
  public equipmentSelectedIds: Set<number> = new Set<number>();
  public associationSelectedIds: Set<number> = new Set<number>();

  iconPacks = EMDMICONS;

  exportHeaderColumns = [
    "EMDM Key",
    "Is Create New",
    "Is Copy",
    "Row Number",
    "Equip Tag Number",
    "Service Type",
    "MWO Number",
    "MWO Description",
    "Maint Status",
    "Performance Standard",
    "Service Days",
    "Last Completed Date",
    "Multiple Flag",
    "Occurrences",
    "Frequency Indicator",
    "Schedule Date",
    "Area Owner Code",
    "Assigned Exec Coord Code"
  ];

  exportEQRouteColumns = [
    "EMDM Key",
    "Is Create New",
    "Is Copy",
    "Row Number",
    "Header Tag",
    "Route Tag",
    "Header Route",
    "Service Type",
    "MWO",
    "Performance Standard",
    "MCTMWO"
  ];

  headerFieldValidationInput: FieldValidation[] = [
    { field: 'emdmKey', title: 'EMDM Key', validations: ["required"] },
    { field: 'isCreateNew', title: 'Is Create New', validations: ["required"] },
    { field: 'isCopy', title: 'Is Copy', validations: ["required"] },
    { field: 'rowNumber', title: 'Row Number', validations: ["required"] },
    { field: 'equipTagNumber', title: 'Equip Tag Number', validations: ["required"] },
    { field: 'serviceType', title: 'Service Type', validations: ["required"] },
    { field: 'mwoNumber', title: 'MWO Number', validations: ["required"] },
    { field: 'mwoProblemDescription', title: 'MWO Description', validations: ["required"] },
    { field: 'mainStatus', title: 'Maint Status', validations: ["required"] },
    { field: 'performanceStandard', title: 'Performance Standard', validations: [] },
    { field: 'serviceDays', title: 'Service Days', validations: ["required"] },
    { field: 'lastCompDate', title: 'Last Completed Date', validations: ["required"] },
    { field: 'multiFlag', title: 'Multiple Flag', validations: [], dataType: "string" },
    { field: 'occurrence', title: 'Occurrences', validations: ["required"] },
    { field: 'frequencyIndicator', title: 'Frequency Indicator', validations: [], dataType: "string" },
    { field: 'schedTickler', title: 'Schedule Date', validations: [] },
    { field: 'maintenanceCoordinatorCode', title: 'Area Owner Code', validations: ["required"] },
    { field: 'planningCoordinatorCode', title: 'Assigned Exec Coord Code', validations: ["required"] }
  ];

  eqRouteValidationInput = [
    { field: 'emdmKey', title: 'EMDM Key', validations: ["required"] },
    { field: 'isCreateNew', title: 'Is Create New', validations: ["required"] },
    { field: 'isCopy', title: 'Is Copy', validations: ["required"] },
    { field: 'rowNumber', title: 'Row Number', validations: ["required"] },
    { field: 'headerTag', title: 'Header Tag', validations: ["required"] },
    { field: 'routeTag', title: 'Route Tag', validations: ["required"] },
    { field: 'headerRoute', title: 'Header Route', validations: ["required"] },
    { field: 'serviceType', title: 'Service Type', validations: ["required"] },
    { field: 'mwo', title: 'MWO', validations: ["required"] },
    { field: 'performanceStandard', title: 'Performance Standard', validations: [] },
    { field: 'mctMwoNumber', title: 'MCTMWO', validations: [] }
  ];
  @ViewChildren(DatePickerComponent) datepickers!: QueryList<DatePickerComponent>;
  constructor(private cdr: ChangeDetectorRef, private renderer: Renderer2, private commonService: commonService, private pmService: PMService,
    private exportService: ExportService, private eRef: ElementRef) {
  }
  

  @HostListener('document:mousedown', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    this.datepickers.forEach((picker) => {
      if (
        picker.isOpen &&
        !target.closest('.k-animation-container') && // Popup container
        !target.closest('.k-datepicker') && // Any DatePicker input
        !target.closest('fa-icon') // Calendar icon
      ) {
        picker.toggle(false); // Close popup
      }
    });
  }

  toggleDatepicker(clickedPicker: DatePickerComponent) {
    // Close all other datepickers
    this.datepickers.forEach(picker => {
      if (picker !== clickedPicker && picker.isOpen) {
        picker.toggle(false);
      }
    });

    // Toggle the clicked one
    clickedPicker.toggle();
  }


  getPMBuild() {
    this.pmService.getPMDataByCrId(this.crNo).subscribe((response: any) => {
      if (response) {

        if (response.headerResponse.length > 0) {
          this.processHeaderData(response.headerResponse);
        }

        if (response.eqRouteResponse.length > 0) {
          this.processEQRouteData(response.eqRouteResponse);
        }

        if (response.pmAssociates.length > 0) {
          this.processAssociateData(response.pmAssociates);
        }
        if (response.warningMessage > 0) {
          this.commonService.showNotificationMessage(response.warningMessage, 'warning', 'center', 200, false);
        }
      }
      this.cdr.detectChanges();
      // setTimeout(() => { this.commonService.styleApplyForNonAccessUser(this.renderer, this.isUserHaveAccess, ['pmBuildGrid1', 'pmBuildGrid2'], ['exportPMBuild', 'backStepNavigation'], ['exportPMBuild', 'clearAllInBuild', 'backStepNavigation']); }, 0);
    });
  }

  setHeaderMessage() {
    let savedTotal = 0; //not added to cr
    let addedTotal = 0; // added to cr
    this.pmViewData.forEach((x: any) => {
      if (x.isAddedToCR) {
        addedTotal++;
      } else {
        savedTotal++;
      }
    })
    if (addedTotal == 0) {
      this.pmHeaderMessage = savedTotal + ' records saved';
    } else if (savedTotal == 0) {
      this.pmHeaderMessage = addedTotal + ' records added';
    }
    else {
      this.pmHeaderMessage = 'total of ' + (addedTotal + savedTotal) + ' : ' + savedTotal + ' saved, ' + addedTotal + ' added';
    }
  }

  processHeaderData(headerResponse: any) {
    headerResponse = headerResponse.map((x: any) => {
      x.fieldChangedList = [];
      x.lastMwoValue = x.mwoNumber;
      x.frequencyIndicator = x.frequencyIndicator === " " ? "" : x.frequencyIndicator;
      if (x.modifiedFields != null && x.modifiedFields != '') {
        x.fieldChangedList = x.modifiedFields.split(";");
      }
      if (x.lastCompDate) {
        let date = new Date(x.lastCompDate ?? "");
        if (date != null && isDate(date) && (date.getFullYear() <= 1901)) {
          x.lastCompDate = null;
          x.lastCompDateEntered = null;
        } else {
          x.lastCompDateEntered = this.dateConverter(x.lastCompDate);
        }
      } else {
        x.lastCompDateEntered = null;

      }
      if (x.schedTickler) {

        let date = new Date(x.schedTickler ?? "");
        if (date != null && isDate(date) && (date.getFullYear() <= 1901)) {
          x.schedTickler = null;
          x.schedTicklerEntered = null;
        } else {
          x.schedTicklerEntered = this.dateConverter(x.schedTickler);
        }
      } else {
        x.schedTicklerEntered = null;

      }
      if (x.serviceType.trim().toLowerCase().startsWith('unschd')) {
        x.disabledItems = true;
      }
      if (x.schedTickler) {
        x.schedTickler = new Date(x.schedTickler);
        x.schedTicklerSelected = new Date(x.schedTickler);
      } else {
        x.schedTickler = null;
      }
      if (x.lastCompDate) {
        x.lastCompDate = new Date(x.lastCompDate);
        x.lastCompDateSelected = new Date(x.lastCompDate);
      } else {
        x.lastCompDate = null;
      }
      return x;
    });
    this.pmViewData = JSON.parse(JSON.stringify(headerResponse.filter((x: any) => x.isStaging)));
    this.pmExportViewData = JSON.parse(JSON.stringify(headerResponse.filter((x: any) => x.isStaging)));
    this.pmOGViewData = JSON.parse(JSON.stringify(headerResponse.filter((x: any) => !x.isStaging)));
    let datetransform = new DateTransformPipe();
    this.setHeaderMessage();
    this.pmExportViewData = this.pmViewData.map((x: any) => {
      return {
        "emdmKey": x.emdmKey,
        "isCreateNew": x.isCreateNew,
        "isCopy": x.isCopy,
        "rowNumber": x.rowNumber,
        "equipTagNumber": x.equipTagNumber,
        "serviceType": x.serviceType,
        "mwoNumber": x.mwoNumber,
        "mwoProblemDescription": x.mwoProblemDescription,
        "mainStatus": x.mainStatus,
        "performanceStandard": x.performanceStandard,
        "serviceDays": x.serviceDays,
        "lastCompDate": x.lastCompDate ? datetransform.transform(new Date(x.lastCompDate), "yyyy/MM/dd", true) : '',
        "multiFlag": x.multiFlag,
        "occurrence": x.occurrence,
        "frequencyIndicator": x.frequencyIndicator,
        "schedTickler": x.schedTickler ? datetransform.transform(new Date(x.schedTickler), "yyyy/MM/dd", true) : '',
        "maintenanceCoordinatorCode": x.maintenanceCoordinatorCode,
        "planningCoordinatorCode": x.planningCoordinatorCode
      }
    });
    this.pmViewData = this.pmViewData.map((x: any) => {
      return {
        ...x,
        lastCompDate: x.lastCompDate ? new Date(x.lastCompDate) : null,
        schedTickler: x.schedTickler ? new Date(x.schedTickler) : null
      };
    })
    this.pmOGViewData = this.pmOGViewData.map((x: any) => {
      return {
        ...x, lastCompDate: x.lastCompDate ? new Date(x.lastCompDate) : null,
        schedTickler: x.schedTickler ? new Date(x.schedTickler) : null
      };
    })
  }

  processEQRouteData(eqRouteResponse: any) {
    eqRouteResponse = eqRouteResponse.map((x: any) => {
      x.fieldChangedList = [];
      x.isView = true;
      x.isLocallyCreated = false;
      let parentIndex = this.pmViewData.findIndex((masterData: any) => x.changeItemPmId == masterData.id);
      if (parentIndex > -1) {
        x.isParentIndexIsOdd = parentIndex + 1;
      }
      if (x.modifiedFields != null && x.modifiedFields != '') {
        x.fieldChangedList = x.modifiedFields.split(";");
      }

      return x;
    });

    this.equipmentRouteViewData = JSON.parse(JSON.stringify(eqRouteResponse.filter((x: any) => x.isStaging)));
    this.equipmentRouteExportViewData = JSON.parse(JSON.stringify(eqRouteResponse.filter((x: any) => x.isStaging)));
    this.equipmentRouteViewData_Filtered = JSON.parse(JSON.stringify(eqRouteResponse.filter((x: any) => x.isStaging)));
    this.equipmentRouteOGData = JSON.parse(JSON.stringify(eqRouteResponse.filter((x: any) => !x.isStaging)));

    this.equipmentRouteExportViewData = this.equipmentRouteViewData.map((x: any) => {
      return {
        "emdmKey": x.emdmKey,
        "isCreateNew": x.isCreateNew,
        "isCopy": x.isCopy,
        "rowNumber": x.rowNumber,
        "headerTag": x.headerTag,
        "routeTag": x.routeTag,
        "headerRoute": x.headerRoute,
        "serviceType": x.serviceType,
        "mwo": x.mwo,
        "performanceStandard": x.performanceStandard,
        "mctMwo_Number": x.mctMwoNumber
      }
    });
  }

  processAssociateData(associateResponse: any) {
    associateResponse = associateResponse.map((x: any) => {
      x.fieldChangedList = [];
      x.isView = true;
      x.isLocallyCreated = false;
      if (this.pmViewData.some((x: any) => x.acdAction === "No change")) {
        this.parentAssocationAction = "No change";
      }
      let parentIndex = this.pmViewData.findIndex((masterData: any) => x.changeItemPmId == masterData.id);
      if (parentIndex > -1) {
        x.isParentIndexIsOdd = parentIndex + 1;
      }
      if (x.modifiedFields != null && x.modifiedFields != '') {
        x.fieldChangedList = x.modifiedFields.split(";");
      }
      if (x.supPression == '2') {
        x.supPression = 'Suppressed'
      } else if (x.supPression == '1') {
        x.supPression = 'Separate WO'
      }
      return x;
    });

    this.associationViewData = JSON.parse(JSON.stringify(associateResponse.filter((x: any) => x.isStaging)));
    this.associationViewData_Filtered = JSON.parse(JSON.stringify(associateResponse.filter((x: any) => x.isStaging)));
    this.associationOGData = JSON.parse(JSON.stringify(associateResponse.filter((x: any) => !x.isStaging)));
  }

  isValueChanged = false;
  isUndoClicked = false;
  isdeleteClicked = false;

  loacallyAddNewId = 0;

  fieldList: any[] = ['serviceType', 'mwoNumber', 'frequencyIndicator', 'serviceDays',
    'maintenanceCoordinatorCode', 'planningCoordinatorCode'];

  validateInput(field: string, event: Event) {
    if (field == 'frequencyIndicator') {
      const input = event.target as HTMLInputElement;
      const value: any = input.value;
      input.value = value.replace(/[^a-zA-Z0-9\W]/g, '');
      //if (value.trim() == '-' || (value.trim() !== '' && !isNaN((value)))) {
      //  input.value = input.value.replace(/-/g, '');
      //}


      //frequency indicator is not validating any values it directly accepts single digit/alphabet/special character as per outsystem
     

    }
  }

  dateConverter(dateInput: any) {
    let date = new Date(dateInput);
    const formattedDate = date.toLocaleDateString("en-GB"); // Outputs: 25/06/2025
    // const finalFormat = formattedDate.split('/').join('-');
    return formattedDate;//finalFormat
  }

  onHeaderValueChange(dataItem: any, field: string, event: any, isDateField: boolean = false, isMwoValueNotfromPopup: boolean = true, DateChange: string = "") {
    if (!isDateField)
      event ??= "";
    this.isUndoClicked = false;
    this.isValueChanged = true;
    dataItem.fieldChangedList ??= [];
    if (field == 'schedTickler') {
      dataItem.schedTickler = event;
    }
    if (field == 'lastCompDate') {
      dataItem.lastCompDate = event;
    }
    if (dataItem.serviceDays == null) {
      dataItem.serviceDays = 0;
    }
    if (field == 'lastCompDateSelected') {
      let date = new Date(event);
      let datetransform = new DateTransformPipe();
      dataItem.lastCompDateEntered = datetransform.transform(date, "dd/MM/yyyy", true);
      dataItem.lastCompDate = date;
      DateChange = "lastCompDate"
    }
    if (field == 'schedTicklerSelected') {
      let date = new Date(event);
      let datetransform = new DateTransformPipe();
      dataItem.schedTicklerEntered = datetransform.transform(date, "dd/MM/yyyy", true);
      DateChange = "schedTickler"
    }

    if (field == 'lastCompDateEntered' && event != "") {
      let validDate: any = this.replaceMMDD(event);
      if (new Date(validDate).getFullYear() >= 1754) {
        dataItem.lastCompDateSelected = new Date(validDate);
        dataItem.lastCompDate = new Date(validDate);
      }
    } else {
      dataItem.lastCompDate = ((field == 'lastCompDateSelected' || dataItem.lastCompDate) &&  event != "") ? dataItem.lastCompDate : null;

    }
    if (field == 'schedTicklerEntered' && event != "") {
      let validDate: any = this.replaceMMDD(event);
      if (new Date(validDate).getFullYear() >= 1754) {
        dataItem.schedTicklerSelected = new Date(validDate);
        dataItem.schedTickler = new Date(validDate);
      }
    } else {
      dataItem.schedTickler = ((field == 'schedTicklerSelected' || dataItem.schedTickler) && event != "") ? dataItem.schedTickler : null;
    }

    let fieldCheck : string = '';
    if(field == 'lastCompDateEntered' || field == 'schedTicklerEntered' || field == 'lastCompDateSelected' || field == 'schedTicklerSelected') {
      fieldCheck = DateChange;
    }
    let ogData = this.pmOGViewData.find((x: any) => dataItem.changeItemId == x.changeItemId) as { [key: string]: any };;
    if (ogData != undefined) { 
      if (dataItem.acdAction != 'Add' && !(field == 'lastCompDateEntered' || field == 'schedTicklerEntered' || field == 'lastCompDateSelected' || field == 'schedTicklerSelected')) {
        if (event != null && ogData[field]?.toString() !== event?.toString()) {
          if (dataItem.fieldChangedList.find((x: string) => x == field) == undefined) {
            if (field == 'lastCompDateEntered' || field == 'schedTicklerEntered' || field == 'lastCompDateSelected' || field == 'schedTicklerSelected') {
              dataItem.fieldChangedList.push(DateChange);
            } else {
              dataItem.fieldChangedList.push(field);
            }
          }
        }
        else {
          if (field == 'lastCompDateEntered' || field == 'schedTicklerEntered' || field == 'lastCompDateSelected' || field == 'schedTicklerSelected') {
            let index = dataItem.fieldChangedList.findIndex((x: string) => x == DateChange);
            if (index > -1) {
              dataItem.fieldChangedList.splice(index, 1);

            }
          } else {

            let index = dataItem.fieldChangedList.findIndex((x: string) => x == field);
            if (index > -1) {
              dataItem.fieldChangedList.splice(index, 1);

            }
          }
        }

        dataItem.acdAction = dataItem.fieldChangedList == 0 ? 'No change' : 'Change';
        dataItem.acdId = this.setACDID(dataItem.acdAction);
      }
      else {
        let datetransform = new DateTransformPipe();
        fieldCheck = fieldCheck == '' ? field : fieldCheck;
        if (event != null && datetransform.transform(ogData[fieldCheck], "dd/MM/yyyy", true) !== datetransform.transform(event, "dd/MM/yyyy", true)) {
          if (dataItem.fieldChangedList.find((x: string) => x == fieldCheck) == undefined) {
            if (field == 'lastCompDateEntered' || field == 'schedTicklerEntered' || field == 'lastCompDateSelected' || field == 'schedTicklerSelected') {
              dataItem.fieldChangedList.push(DateChange);
            } else {
              dataItem.fieldChangedList.push(field);
            }
          }
        }
        else {
          if (field == 'lastCompDateEntered' || field == 'schedTicklerEntered' || field == 'lastCompDateSelected' || field == 'schedTicklerSelected') {
            let index = dataItem.fieldChangedList.findIndex((x: string) => x == DateChange);
            if (index > -1) {
              dataItem.fieldChangedList.splice(index, 1);

            }
          } else {

            let index = dataItem.fieldChangedList.findIndex((x: string) => x == field);
            if (index > -1) {
              dataItem.fieldChangedList.splice(index, 1);

            }
          }
        }
      }

      dataItem.acdAction = dataItem.fieldChangedList == 0 ? 'No change' : 'Change';
      dataItem.acdId = this.setACDID(dataItem.acdAction);
    }
    if (field == 'serviceType') {
      this.serviceTypeChange(dataItem);
    }
    if (field == 'serviceDays') {
      let changedRow = this.associationViewData.filter((eqData: any) => eqData.changeItemPmId == dataItem.id);
      changedRow.forEach(headerItem => {
        const eqItem = this.associationViewData.find(eqItem => eqItem.changeItemId === headerItem.changeItemId);
        if (eqItem) {
          headerItem.serviceDays = event;
        }
      });
      this.headerSelectionFilter();
    }

    let timeoutId;
    if (field == 'mwoNumber' && isMwoValueNotfromPopup) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        this.mwoNumberChange(dataItem);
      }, 2000);
    }
    console.log('Header Value Changed', dataItem);
  }

  mwoNumberChange(dataItem: any) {
    if (dataItem.mwoNumber != dataItem.lastMwoValue) {
      if (dataItem.mwoNumber != '' && dataItem.mwoNumber != "0") {
        dataItem.lastMwoValue = dataItem.mwoNumber
        this.pmService.getMwoValid(dataItem.mwoNumber, this.crNo).subscribe({
          next: (response: any) => {
            if (response) {

              this.mwoValueChanged(response, dataItem.mwoNumber, dataItem.changeItemId);
            }

          }
        })
      }
      else {
        this.mwoValueChanged([], dataItem.mwoNumber, dataItem.changeItemId);
      }
    }
  }

  undoHeaderById(changeItemId: number) {
    this.isUndoClicked = true;
   
    let viewDataIndex = this.pmViewData.findIndex((x: any) => changeItemId == x.changeItemId);
    if (viewDataIndex >= 0) {
      let ogDataItem = this.pmOGViewData.find((x: any) => changeItemId == x.changeItemId);
      if (ogDataItem) {
        let oldId = this.pmViewData[viewDataIndex].id;
        this.pmViewData[viewDataIndex] = JSON.parse(JSON.stringify(ogDataItem));
        this.pmViewData[viewDataIndex].id = oldId;
        this.pmViewData[viewDataIndex].isStaging = true;
        this.pmViewData[viewDataIndex].fieldChangedList = [];
        this.pmViewData[viewDataIndex].modifiedFields = "";
        this.pmViewData[viewDataIndex].acdAction = 'No change';
        this.pmViewData[viewDataIndex].acdId = this.setACDID('No change');

        let headerData = this.pmViewData[viewDataIndex];
       

        //Equipment Route Child Action Change - Start

        if (this.isdeleteClicked)
        { 
          this.equipmentRouteViewData_Filtered.filter((associateData: any) => headerData.id == associateData.changeItemPmId).forEach((associateData: any) => {
            associateData.acdAction = "No change";
            associateData.acdId = this.commonService.setACDID("No change");
          });

          this.equipmentRouteViewData.filter((associateData: any) => headerData.id == associateData.changeItemPmId).forEach((associateData: any) => {
            associateData.acdAction = "No change";
            associateData.acdId = this.commonService.setACDID("No change");
          });

          //Equipment Route Child Action Change - End

          //Association Child Action Change - Start

          this.associationViewData_Filtered.filter((associateData: any) => associateData.changeItemPmId == headerData.id)
            .forEach((associateData: any) => {
              associateData.acdAction = "No change";
              associateData.acdId = this.commonService.setACDID("No change");
              associateData.serviceDays = headerData.serviceDays;
            });

          this.associationViewData.filter((associateData: any) => associateData.changeItemPmId == headerData.id)
            .forEach((associateData: any) => {
              associateData.acdAction = "No change";
              associateData.acdId = this.commonService.setACDID("No change");
              associateData.serviceDays = headerData.serviceDays;
            });
        }
        this.isdeleteClicked = false;
        //Association Child Action Change - End
      }
    }
    this.setHeaderMessage();
  }

  setACDID(action: string): number {
    if (action === 'Add')
      return 1;
    else if (action === 'Delete')
      return 2;
    else if (action === 'Change')
      return 3;
    else if (action === 'No change')
      return 4;

    return 0;
  }

  undoSelected() {
    this.isUndoClicked = true;
    this.headerSelectedIds.forEach((selectedId: any) => {
      let viewDataIndex = this.pmViewData.findIndex((x: any) => selectedId == x.changeItemId && x.acdAction != "Add");
      if (viewDataIndex >= 0) {
        let ogDataItem = this.pmOGViewData.find((x: any) => selectedId == x.changeItemId);
        if (ogDataItem) {
          let oldId = this.pmViewData[viewDataIndex].id;
          this.pmViewData[viewDataIndex] = JSON.parse(JSON.stringify(ogDataItem));
          this.pmViewData[viewDataIndex].id = oldId;
          this.pmViewData[viewDataIndex].isStaging = true;
          this.pmViewData[viewDataIndex].fieldChangedList = [];
          this.pmViewData[viewDataIndex].acdAction = 'No change';
          this.pmViewData[viewDataIndex].acdId = this.setACDID('No change');

          let headerData = this.pmViewData[viewDataIndex];

          //Equipment Route Child Action Change - Start

          this.equipmentRouteViewData_Filtered.filter((equipmentRouteData: any) => headerData.id == equipmentRouteData.changeItemPmId)
            .forEach((equipmentRouteData: any) => {
              equipmentRouteData.acdAction = "No change";
              equipmentRouteData.acdId = this.commonService.setACDID("No change");
            });

          this.equipmentRouteViewData.filter((equipmentRouteData: any) => headerData.id == equipmentRouteData.changeItemPmId)
            .forEach((equipmentRouteData: any) => {
              equipmentRouteData.acdAction = "No change";
              equipmentRouteData.acdId = this.commonService.setACDID("No change");
            });

          //Equipment Route Child Action Change - End

          //Association Child Action Change - Start

          this.associationViewData_Filtered.filter((associateData: any) => associateData.changeItemPmId == headerData.id)
            .forEach((associateData: any) => {
              associateData.acdAction = "No change";
              associateData.acdId = this.commonService.setACDID("No change");
            });

          this.associationViewData.filter((associateData: any) => associateData.changeItemPmId == headerData.id)
            .forEach((associateData: any) => {
              associateData.acdAction = "No change";
              associateData.acdId = this.commonService.setACDID("No change");
            });

          //Association Child Action Change - End
        }
      }
    });
  }

  deleteSelected() {
    let selectedActions = new Set<string>(JSON.parse(JSON.stringify(this.pmViewData.filter((viewData: any) => this.headerSelectedIds.has(viewData.changeItemId)).map((viewData: any) => viewData.acdAction?.toLocaleLowerCase()))));

    if (selectedActions.size == 1 || (selectedActions.size > 1 && (!selectedActions.has("add")))) {
      if (selectedActions.has("no change") || selectedActions.has("change")) {
        this.headerSelectedIds.forEach((itemId: number) => {
          let index = this.pmViewData.findIndex((x: PMBuild) => x.changeItemId == itemId);
          if (index >= 0 && this.pmViewData[index].acdAction?.toLocaleLowerCase() != 'add' && this.pmViewData[index].acdAction?.toLocaleLowerCase() != 'delete') {
            this.pmViewData[index].acdAction = "Delete";
            this.pmViewData[index].acdId = this.commonService.setACDID("Delete");

            let headerData = this.pmViewData[index];
            this.equipmentRouteViewData_Filtered.filter((associateData: any) => headerData.id == associateData.changeItemPmId).forEach((associateData: any) => {
              associateData.acdAction = "Delete";
              associateData.acdId = this.commonService.setACDID("Delete");
            });

            this.equipmentRouteViewData.filter((associateData: any) => headerData.id == associateData.changeItemPmId).forEach((associateData: any) => {
              associateData.acdAction = "Delete";
              associateData.acdId = this.commonService.setACDID("Delete");
            });

            this.associationViewData_Filtered.filter((associateData: any) => associateData.changeItemPmId == headerData.id)
              .forEach((associateData: any) => {
                associateData.acdAction = "Delete";
                associateData.acdId = this.commonService.setACDID("Delete");
              });

            this.associationViewData.filter((associateData: any) => associateData.changeItemPmId == headerData.id)
              .forEach((associateData: any) => {
                associateData.acdAction = "Delete";
                associateData.acdId = this.commonService.setACDID("Delete");
              });
          }
        });
      }
      else if (selectedActions.has("add")) {
        this.clearPM(false, false);
      }
      this.setHeaderMessage();
    } else {
      this.commonService.showNotificationMessage(`Unable to execute this action.<br>
        Please select either existing record(s) or new record(s) but not both.`, "error", "center");
    }
  }

  clickExport(gridName: string): void {
    let custName = (gridName == "Header" ? "export_pm_schedules_CR" : "export_routes_CR") + this.crNo + "_" + this.commonService.getCurrentUTCDateTime();


    let exportColumns = gridName == "Header" ? this.exportHeaderColumns : this.exportEQRouteColumns;
    let exportData = gridName == "Header" ? this.pmExportViewData : this.equipmentRouteExportViewData;

    this.exportService.exportExcel(exportData, [exportColumns], custName);
    this.commonService.showNotificationMessage(
      'file downloaded successfully',
      'success',
      'center'
    );
  }

  addNewPM() {
    this.pmService.addNewPM(this.crNo).subscribe((response: any) => {
      if (response.headerResponse.length > 0) {
        let latestrecord = JSON.parse(JSON.stringify(response.headerResponse.filter((eqData: any) => !this.pmViewData.some((selected: any) => eqData.changeItemId == selected.changeItemId))));
        latestrecord[0].lastCompDateEntered ="";
        latestrecord[0].schedTicklerEntered = "";
        this.pmViewData = [...this.pmViewData, ...latestrecord];
      }

      if (response.eqRouteResponse.length > 0) {
        let latestrecord = JSON.parse(JSON.stringify(response.eqRouteResponse.filter((eqData: any) => !this.equipmentRouteViewData.some((selected: any) => eqData.changeItemId == selected.changeItemId))));
        this.equipmentRouteViewData = [...this.equipmentRouteViewData, ...latestrecord];
      }

      if (response.pmAssociates.length > 0) {
        let latestrecord = JSON.parse(JSON.stringify(response.pmAssociates.filter((eqData: any) => !this.associationViewData.some((selected: any) => eqData.changeItemId == selected.changeItemId))));
        this.associationViewData = [...this.associationViewData, ...latestrecord];
      }

      this.headerSelectionFilter();
      this.setHeaderMessage();
    });
  }

  deletePMbyId(changeItemId: number, acdAction: string, deletedHeaderId: number) {
    this.isdeleteClicked = true;
    let payload = {
      "crid": this.crNo,
      "changeitemid": changeItemId.toString(),
      "flag": "Selected"
    };

    if (acdAction == "Add") {
      this.pmService.deletePMBuild(payload).subscribe({
        next: (response: any) => {
          if (response) {

            this.headerSelectedIds.clear();

            this.pmViewData = this.pmViewData.filter((x: any) => x.changeItemId != changeItemId);
            this.pmOGViewData = this.pmOGViewData.filter((x: any) => x.changeItemId != changeItemId);

            this.equipmentRouteViewData = this.equipmentRouteViewData.filter((x: any) => x.changeItemPmId != deletedHeaderId);
            // this.equipmentRouteViewData_Filtered = this.equipmentRouteViewData_Filtered.filter((x: any) => x.changeItemPmId != deletedHeaderId);
            this.equipmentRouteOGData = this.equipmentRouteOGData.filter((x: any) => x.changeItemPmId != deletedHeaderId);

            this.associationViewData = this.associationViewData.filter((x: any) => x.changeItemPmId != deletedHeaderId);
            this.associationOGData = this.associationOGData.filter((x: any) => x.changeItemPmId != deletedHeaderId);
            // this.associationViewData_Filtered = this.associationViewData_Filtered.filter((x: any) => x.changeItemPmId != deletedHeaderId);

            this.headerSelectionFilter();
          }
        }
      });
    } else if (acdAction == "Change") {
      let viewDataIndex = this.pmViewData.findIndex((x: any) => x.id == deletedHeaderId);
      let ogDataIndex = this.pmOGViewData.findIndex((x: any) => x.changeItemId == changeItemId);
      if (viewDataIndex > -1 && ogDataIndex > -1) {
        let oldId = this.pmViewData[viewDataIndex].id;
        this.pmViewData[viewDataIndex] = JSON.parse(JSON.stringify(this.pmOGViewData[ogDataIndex]));
        this.pmViewData[viewDataIndex].id = oldId;
        this.pmViewData[viewDataIndex].isStaging = !this.pmViewData[viewDataIndex].isStaging;
        this.pmViewData[viewDataIndex].acdAction = "Delete";
        this.pmViewData[viewDataIndex].acdId = this.commonService.setACDID("Delete");

        this.equipmentRouteViewData.filter((x: any) => this.pmViewData[viewDataIndex].id == x.changeItemPmId).forEach((x: any) => {
          x.acdAction = "Delete";
          x.acdId = this.commonService.setACDID("Delete");
        });

        this.equipmentRouteViewData_Filtered.filter((x: any) => this.pmViewData[viewDataIndex].id == x.changeItemPmId).forEach((x: any) => {
          x.acdAction = "Delete";
          x.acdId = this.commonService.setACDID("Delete");
        });

        this.associationViewData.filter((x: any) => this.pmViewData[viewDataIndex].id == x.changeItemPmId).forEach((x: any) => {
          x.acdAction = "Delete";
          x.acdId = this.commonService.setACDID("Delete");
        });

        this.associationViewData_Filtered.filter((x: any) => this.pmViewData[viewDataIndex].id == x.changeItemPmId).forEach((x: any) => {
          x.acdAction = "Delete";
          x.acdId = this.commonService.setACDID("Delete");
        });
      }
    }
    this.setHeaderMessage();
  }

  dataInitialization() {
    this.pmViewData = [];
    this.pmOGViewData = [];

    this.equipmentRouteOGData = [];
    this.equipmentRouteViewData = [];
    this.equipmentRouteViewData_Filtered = [];

    this.associationOGData = [];
    this.associationViewData = [];
    this.associationViewData_Filtered = [];

    this.headerSelectedIds.clear();
    this.equipmentSelectedIds.clear();
    this.associationSelectedIds.clear();
    this.headerRouteTagSearchText = "";
    this.headerTagSearchText.clear();
    this.routeTagSearchText.clear();

    this.isUndoClicked = false;
    this.isValueChanged = false;
  }

  clearPM(isSelectedAll: boolean, isConfirmationNeeded: boolean = true) {
    let confirmationMsg = isSelectedAll ? "All PMs, not just selected, will be cleared from CR. Are you sure?" :
      "All selected records but the ones already added to CR will be cleared. Are you sure?";

    let isConfirmed = isConfirmationNeeded ? confirm(confirmationMsg) : !isConfirmationNeeded;

    if (isConfirmed) {
      if (this.pmViewData.length > 0) {
        let payload = {
          crid: this.crNo,
          changeitemid: isSelectedAll ? "" : Array.from(this.headerSelectedIds).join(","),
          flag: isSelectedAll ? "SelectedAll" : "Selected"
        };

        this.pmService.deletePMBuild(payload).subscribe({
          next: (response: any) => {
            if (response) {
              let count = isSelectedAll ? this.pmViewData.length : this.headerSelectedIds.size;
              let successMsg = `${count} record(s) cleared from CR successfully.`;

              this.commonService.showNotificationMessage(successMsg, "success", "center");

              this.dataInitialization();
              this.getPMBuild();
            }
          }
        });
      } else{
                      this.commonService.showNotificationMessage('No record available', 'error', 'center');
      }
    }
    // IN OUT System there is no message on canceling in clear All and clear selected
    // else {
    //   this.commonService.showNotificationMessage('No record available', 'error', 'center');
    // }
    this.setHeaderMessage();
  }

  public expandCollapseContent(): void {
    this.expandedState = !this.expandedState;
  }

  saveAndAddToCr() {
    let isActionConfirmed = window.confirm("Are you sure?");

    if (isActionConfirmed) {
      this.checkMwoExists();
      this.mwoErrorTextList = [];
    }
  }

  options: any = { year: 'numeric', month: '2-digit', day: '2-digit' };

  checkMwoExists() {

    let validateMWOExist = false;
    if ("shouldValidateMWOExist" in sessionStorage) {
      validateMWOExist = sessionStorage.getItem("shouldValidateMWOExist")?.toLocaleLowerCase() === "true";
    }

    let viewPayload = this.commonService.deepClone(this.pmViewData);
    let datetransform = new DateTransformPipe();
    viewPayload?.forEach((x: any) => {
      x.modifiedFields = x.fieldChangedList?.join(';') || null
      let date: Date;
      if (typeof x.lastCompDate === 'string' && x.lastCompDate.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        const [day, month, year] = x.lastCompDate.split('/').map(Number);
        date = new Date(year, month - 1, day);
      } else {
        date = new Date(x.lastCompDate ?? "");
      }
      let pipe = new DateTransformPipe();
      if (x.lastCompDate != null && isDate(date)) {
        date.setHours(0, 0, 0, 0);
        x.lastCompDate = datetransform.transform(date, "yyyy-MM-ddThh:mm:ss");
      }

      // x.lastCompDateFormatted = x.lastCompDateFormatted ? String(x.lastCompDateFormatted).split('T')[0] : '';

      
      if (typeof x.schedTickler === 'string' && x.schedTickler.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
        const [day, month, year] = x.schedTickler.split('/').map(Number);
        date = new Date(year, month - 1, day);
      } else {
        date = new Date(x.schedTickler ?? "");
      }
      if (x.schedTickler != null && isDate(date)) {
        date.setHours(0, 0, 0, 0);
        x.schedTickler = datetransform.transform(date, "yyyy-MM-ddThh:mm:ss");
      }
    });

    let payload = {
      headerResponse: viewPayload,
      eqRouteResponse: this.equipmentRouteViewData,
      pmAssociates: this.associationViewData
    };
    //let mwoList = this.pmViewData?.flatMap((data: any) => data?.mwoNumber?.split(',').map((mwo: string) => mwo.trim()));
    let mwoList = this.pmViewData
      ?.filter((data: any) => data?.mwoNumber) // Filter out null/undefined mwoNumber first
      ?.flatMap((data: any) => data.mwoNumber.split(',')?.map((mwo: string) => mwo?.trim()))
      ?.filter((mwo: string) => mwo !== null && mwo !== undefined && mwo.trim() !== "" && mwo.trim().length > 0)
      ?.filter((mwo: string) => !mwo.toUpperCase().includes('MCTMWO')); // Exclude MWOs containing MCTMWO
    if (validateMWOExist && mwoList.length > 0) {
      this.pmService.checkMwoNumberExists(this.crNo, mwoList).subscribe({
        next: (response: any) => {
          if (response.length > 0) {
            this.mwoErrorTextList = response;
          } else {
            this.mwoErrorTextList = [];
            this.validatePmBuild(payload);
          }
        },
        error: () => {
        }
      });
    } else {
      this.validatePmBuild(payload);
    }
  }

  validatePmBuild(payload: any) {
    let validatePayload = this.resetPayload(payload, false);
    this.pmService.validatePMBuild(this.crNo, validatePayload).subscribe({
      next: (response: any) => {
        if (response.headers.length != 0 || response.routes.length != 0 || response.associations.length != 0) {
          this.pmViewData.filter((x: any) => {
            x.errorList = [];
          });
          this.associationViewData.filter((x: any) => {
            x.errorList = [];
          });
          this.equipmentRouteViewData.filter((x: any) => {
            x.errorList = [];
          });
          let fullMsg = '';
          response.headers.filter((x: any) => x.fieldList != null).forEach((x: any) => {
            let fieldList = x.fieldList?.split(";");
            fieldList = fieldList.filter((fieldnamevalue: any) => fieldnamevalue !== '');
            this.pmViewData[x.rowNumber - 1].errorList = fieldList;
          });

          response.routes.filter((x: any) => x.fieldList != null).forEach((x: any) => {

            let fieldList = x.fieldList?.split(";");
            fieldList = fieldList.filter((fieldnamevalue: any) => fieldnamevalue !== '');

            // only for Duplicate Route error - read line number to higth light error
            let searchString = "Duplicate Route";
            if (x.errorMessage.includes(searchString)) {

              let errorMessage = x.errorMessage;
              let startIndex = 0;

              while ((startIndex = errorMessage.indexOf(searchString, startIndex)) !== -1) {
                let lineStart = errorMessage.lastIndexOf("Route Line ", startIndex);
                let lineEnd = errorMessage.indexOf(":", lineStart);
                let lineNumber = errorMessage.substring(lineStart + 11, lineEnd).trim();
                startIndex += searchString.length;
                this.equipmentRouteViewData[parseInt(lineNumber, 10) - 1].errorList += fieldList;
              }
            } else {
              this.equipmentRouteViewData[x.rowNumber - 1].errorList += fieldList;
            }
          });
          response.associations.filter((x: any) => x.fieldList != null).forEach((x: any) => {
            let fieldList = x.fieldList?.split(";");
            fieldList = fieldList.filter((fieldnamevalue: any) => fieldnamevalue !== '');
            this.associationViewData[x.rowNumber - 1].errorList = fieldList;
          });


          let responseCombinedArray = [...response.headers, ...response.associations, ...response.routes];

          let errorMessages: any[] = responseCombinedArray.filter((x: any) => x.errorMessage != '' || x.fieldList != '').map((x: any) => ({
            errorMessage: x.errorMessage, fieldList: x.fieldList, rowNumber: x.rowNumber
          }));

          let isAllErrorMessagesNull = responseCombinedArray.every((x: any) => !x.errorMessage);

          if (isAllErrorMessagesNull) {

            let warningMessages = responseCombinedArray.filter((x: any) => x.warningMessage).map(data => data.warningMessage);
            if (warningMessages.length) {
              // fullMsg = `There are ${warningMessages.length} warning(s): <br />`
              fullMsg += warningMessages.join('<br />');
              // this.commonService.showNotificationMessage(fullMsg, 'warning', 'center',200, false);
              this.savePmBuild(payload, fullMsg);
              return;
            }
          }
          let finalErrorMessage = '';
          if (response.errorCount > 5) {
            fullMsg = `There are ${response.errorCount} errors and the first 5 are <br>`
            fullMsg += response.headers.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            fullMsg += response.routes.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            fullMsg += response.associations.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            fullMsg = fullMsg.replace(/,/g, '');
            let msg = fullMsg.split('<br>');
            msg = msg.splice(0, 6);
            finalErrorMessage = msg.join('<br>');
          }
          else if (response.errorCount == 1) {
            fullMsg = `There is ${response.errorCount} error: <br>`
            fullMsg += response.headers.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            fullMsg += response.routes.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            fullMsg += response.associations.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            fullMsg = fullMsg.replace(/,/g, '');
            finalErrorMessage = fullMsg;
          }
          else {
            fullMsg = `There are ${response.errorCount} errors: <br>`
            fullMsg += response.headers.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            fullMsg += response.routes.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            fullMsg += response.associations.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            fullMsg = fullMsg.replace(/,/g, '');
            finalErrorMessage = fullMsg;
          }


          this.commonService.showNotificationMessage(finalErrorMessage, 'error', 'center');
          this.headerSelectedIds.clear();
          this.headerSelectionFilter();
          this.pmViewData = [...this.pmViewData]
        } else {
          this.savePmBuild(payload, '');
        }
      },
      error: () => {
      }
    });
  }

  parseRoutes(routes: any[]) {
    const data: any = {};

    routes.forEach(route => {
      // Extracting the row number
      const rowNumber = route.rowNumber;

      const errors = route.errorMessage.split('<br>').filter(Boolean);

      if (!data[rowNumber]) {
        data[rowNumber] = { fieldList: [], errorMessage: [] };
      }

      errors.forEach((error: string) => {
        const match = error.match(/Route Line \d+\| (.*)/);
        if (match) {
          data[rowNumber].errorMessage.push(`Route Line ${rowNumber}| ${match[1].trim()} <br>`);
          data[rowNumber].fieldList.push(route.fieldList.trim());
        }
      });
    });

    const sortedData = Object.keys(data).sort((a: any, b: any) => a - b).map(rowNumber => ({
      rowNumber: parseInt(rowNumber, 10),
      fieldList: data[rowNumber].fieldList,
      errorMessage: data[rowNumber].errorMessage
    }));

    return sortedData;
  }

  resetPayload(payload: any, isValidatePayload: boolean) {
    if (isValidatePayload) {
      payload.pmAssociates.forEach((x: any) => {
        if (x.supPression != '') {
          if (x.supPression = 'Supressed') {
            x.supPression = '2';
          } else {
            x.supPression = '1';
          }
        }
      })
    }
    payload.headerResponse.forEach((x: any) => {
      if (!x.serviceDays) {
        x.serviceDays = 0;
      }
      if (x.serviceType != null && x.serviceType.toUpperCase().includes("UNSCHD")) {
        x.schedType = "1";
      }
      if (x.lastCompDateEntered) {
        let lastCompDateEntered = x.lastCompDateEntered;

        let lastCompDateEnteredValid = true;
        if (lastCompDateEntered) {
          // Check for valid date format: dd/mm/yyyy
          const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
          if (!dateRegex.test(lastCompDateEntered)) {
            lastCompDateEnteredValid = false;
          } else {
            const [day, month, year] = lastCompDateEntered.split('/').map(Number);
            const dateObj = new Date(year, month - 1, day);
            if (
              dateObj.getFullYear() !== year ||
              dateObj.getMonth() !== month - 1 ||
              dateObj.getDate() !== day ||
              year < 1901 ||
              year > 9999
            ) {
              lastCompDateEnteredValid = false;
            }
          }
        }

        if(!lastCompDateEnteredValid){
          x.lastCompDate = null;
          x.lastCompDateFormatted = x.lastCompDateEntered;
        } else {

          const [day, month, year] = lastCompDateEntered.split('/');

          if (year >= 1754) {
            // const isoDateString = `${year}/${month}/${day}T00:00:00Z`;// new Date(isoDateString) gives error  / 
            const isoDateString = `${year}-${month}-${day}T00:00:00Z`;
            x.lastCompDate = new Date(isoDateString);
            x.lastCompDateFormatted = null;
          } else {
            x.lastCompDate = null;
            x.lastCompDateFormatted = x.lastCompDateEntered;
          }
        }
      }

      // if (x.schedTicklerEntered) {
      //   let schedTicklerEntered = x.schedTicklerEntered;
      //   let validDate: any = this.replaceMMDD(schedTicklerEntered);
      //   if (new Date(validDate).getFullYear() >= 1754) {
      //     x.schedTickler = new Date(validDate);
      //     x.schedTicklerFormatted = null;
      //   } else {
      //     x.schedTickler = null;
      //     x.schedTicklerFormatted = x.schedTicklerEntered;
      //   }
      // }
      
      if (x.schedTicklerEntered) {
        let schedTicklerEntered = x.schedTicklerEntered;

        let schedTicklerEnteredValid = true;
        if (schedTicklerEntered) {
          // Check for valid date format: dd-mm-yyyy
          const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
          if (!dateRegex.test(schedTicklerEntered)) {
            schedTicklerEnteredValid = false;
          } else {
            const [day, month, year] = schedTicklerEntered.split('/').map(Number);
            const dateObj = new Date(year, month - 1, day);
            // Check for impossible dates (e.g., 233-33-199, dd-mm-1900, etc.)
            if (
              dateObj.getFullYear() !== year ||
              dateObj.getMonth() !== month - 1 ||
              dateObj.getDate() !== day ||
              year < 1901 ||
              year > 9999
            ) {
              schedTicklerEnteredValid = false;
            }
          }
        }

        if(!schedTicklerEnteredValid){
          x.schedTickler = null;
          x.schedTicklerFormatted = x.schedTicklerEntered;
        } else {

          const [day, month, year] = schedTicklerEntered.split('/');

          if (year >= 1754) {
            // const isoDateString = `${year}/${month}/${day}T00:00:00Z`;// new Date(isoDateString) gives error
            const isoDateString = `${year}-${month}-${day}T00:00:00Z`;
            x.schedTickler = new Date(isoDateString);
            x.schedTicklerFormatted = null;
          } else {
            x.schedTickler = null;
            x.schedTicklerFormatted = x.schedTicklerEntered;
          }
        }
      }
    })
    payload.eqRouteResponse.forEach((x: any) => {
      if (x.fieldChangedList?.length > 0) {
        x.modifiedFields = x.fieldChangedList?.join(';');
      }
    })
    return payload;
  }

  replaceMMDD(currentData: any) {
    const [day, month, year] = currentData.split('/');
    const switchedDate = `${month}/${day}/${year}`;
    return switchedDate;
  }

  savePmBuild(payload: any, warningMessage: any) {
    let savePayload = this.resetPayload(payload, true);

    this.pmService.savePMBuild(this.crNo, savePayload).subscribe({
      next: (response: any) => {
        if (response) {
          this.stepNavigateTo.emit("Summary");
        }
        if (warningMessage.length > 0) {
          this.commonService.showNotificationMessage(warningMessage, 'warning', 'center', 200, false);
        }
        else {
          this.commonService.showNotificationMessage('PM Header changes added succesfully', 'success', 'center', 200, false);
        }
      },
      error: (error) => {
        // this.commonService.showNotificationMessage(error, 'error', 'center', 200, false);
      }
    });
  }

  OnSelectionChangeEventGrid(event: SelectionEvent, gridName: string) {
    if (gridName == 'mainGrid') {
      this.headerSelectedIds = this.commonService.onGridSelection(this.headerSelectedIds, event, "changeItemId");
      this.headerSelectionFilter();
    }
    else if (gridName == 'equipment')
      this.equipmentSelectedIds = this.commonService.onGridSelection(this.equipmentSelectedIds, event, "id");
    else if (gridName == 'association')
      this.associationSelectedIds = this.commonService.onGridSelection(this.associationSelectedIds, event, "id");
  }

  popupPageChanged(event: any) {
    if (this.popupOpenField == 'equipTagNumber') {
      this.skip = event.skip;
      this.pageSize = event.pageSize;
      this.searchText = event.searchText;
      this.getEquipPopupData();
    }
    else if (this.popupOpenField == 'minorServiceType') {
      this.skip = event.skip;
      this.pageSize = event.pageSize;
      this.searchText = event.searchText;
      this.getAssociateMinorServiceTypes(this.minorserviceequipTag, this.minorserviceserviceType);
    }
    else if (this.popupOpenField == 'frequencyIndicator') {
      this.skip = event.skip;
      this.pageSize = event.pageSize;
      this.searchText = event.searchText;
      this.getFreqIndicatorData();
    }
    else if (this.popupOpenField == 'serviceType') {
      this.skip = event.skip;
      this.pageSize = event.pageSize;
      this.searchText = event.searchText;
      this.getServiceType();
    }
    else if (this.popupOpenField == 'mwoNumber') {
      this.skip = event.skip;
      this.pageSize = event.pageSize;
      this.searchText = event.searchText;
      this.getMwoData();
    }
  }

  getEquipPopupData() {
    this.pmService.getRouteTag(this.skip, this.pageSize, this.searchText).subscribe({
      next: (response: any) => {
        if (response) {
          this.popupDataList = {
            data: response.item1,
            total: response.item2
          };
          this.popupShow = true;
        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  getFreqIndicatorData() {
    this.pmService.getFreqIndicator(this.skip, this.pageSize, this.searchText).subscribe({
      next: (response: any) => {
        if (response) {
          this.popupDataList = {
            data: response.item1,
            total: response.item2
          };
          this.popupShow = true;
        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  getMwoData() {
    this.pmService.getMwoData(this.skip, this.pageSize, this.searchText, this.crNo).subscribe({
      next: (response: any) => {
        if (response) {
          this.popupDataList = {
            data: response.item1,
            total: response.item2
          };
          this.popupShow = true;
        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  getAssociateMinorServiceTypes(equipTag: string, serviceType: string) {
    this.pmService.getMinorServiceTypes(this.skip, this.pageSize, this.searchText, equipTag, serviceType).subscribe({
      next: (response: any) => {
        if (response) {
          this.popupDataList = {
            data: response.item1,
            total: response.item2
          };
          this.popupShow = true;
        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }


  getServiceType() {
    this.pmService.getServiceType(this.skip, this.pageSize, this.searchText).subscribe({
      next: (response: any) => {
        if (response) {
          this.popupDataList = {
            data: response.item1,
            total: response.item2
          };
          this.popupShow = true;
        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  toggleSpinners_Element(elementId: any, value: string) {
    let element = document.getElementById(elementId);
    if (element) {
      element.setAttribute('spinners', value);
    }
  }

  popupOpenField = "";
  popUpOpenFieldChangeItemId = 0;
  popupShow = false;
  showFileUploadPopup = false;
  lastImportedType: string = "";
  popupTitle = "";
  popupHeight = 440;
  popupWidth = 600;
  isPopUpHasSearch = false;
  searchPlaceHolder = "Search";
  searchButton = "Search";

  openActionPopup(fieldName: string, dataItem: any = null) {
    this.popupOpenField = fieldName;
    this.isPopUpHasSearch = true;
    this.popUpOpenFieldChangeItemId = dataItem?.changeItemId ?? 0;
    if (this.popupOpenField == 'serviceType') {
      this.popupTitle = "Add";
      this.searchPlaceHolder = "Search Service Type";
      this.popupWidth = 600;
      this.popupHeight = 450;
      this.popupGridColumn = this.ServiceTypeSelectColumn;
      this.searchButton = "Search";
      this.getServiceType();
    }
    else if (this.popupOpenField == 'mwoNumber' && dataItem != null) {
      this.popupTitle = "Search MWO Number " + (dataItem?.equipTagNumber ?? '') + (dataItem?.mwoNumber ?? 0);
      this.searchPlaceHolder = "Search MWO, MWO Problem Description, Equip Tag Number or MCTMWO number";
      this.popupWidth = 800;
      this.popupHeight = 500;
      this.popupGridColumn = this.mwoSelectColumn;
      this.searchButton = "Search MWO";
      this.getMwoData();
    }
    else if (this.popupOpenField == 'frequencyIndicator') {
      let OGData = this.pmOGViewData.find((x: PMBuild) => x.changeItemId == this.popUpOpenFieldChangeItemId);
      this.popupTitle = OGData != undefined ? (OGData?.acdAction ?? "") : "Add";
      this.popupGridColumn = this.frequencyIndicatorSelectColumn;
      this.searchPlaceHolder = "Search Frequency Indicator";
      this.getFreqIndicatorData();
      this.popupHeight = 450;
    }
    else if (this.popupOpenField == 'equipTagNumber') {
      this.popUpOpenFieldChangeItemId = dataItem.id;
      this.popupTitle = "Add";
      this.searchPlaceHolder = "Search Equipment Tag Number, Description or Subclass";
      this.popupWidth = 800;
      this.popupGridColumn = this.equipmentSelectColumn;
      this.searchButton = "Search";
      this.getEquipPopupData();
      this.popupHeight = 450;
    }
    else if (this.popupOpenField == 'minorServiceType') {
      this.popupTitle = this.parentAssocationAction;
      
      this.isPopUpHasSearch = false;
      this.searchPlaceHolder = "";
      this.popupWidth = 600;
      this.popupHeight = 450;
      this.popupGridColumn = this.minorServiceTypeSelectColumn;
      this.popUpOpenFieldChangeItemId = dataItem.id;

      this.minorserviceequipTag = dataItem.equipTagNumber;
      this.minorserviceserviceType = dataItem.majorServiceType;
      this.getAssociateMinorServiceTypes(this.minorserviceequipTag, this.minorserviceserviceType);
    }
    else if (this.popupOpenField == 'pmmwoerror') {

    }
    this.popupShow = true;
  }

  dataItemSelcted(dataItem: any) {

    if (this.popupOpenField != '' && this.popUpOpenFieldChangeItemId > 0) {
      if (this.popupOpenField == 'serviceType') {
        let viewDataIndex = this.pmViewData.findIndex((x: PMBuild) => x.changeItemId == this.popUpOpenFieldChangeItemId);

        if (viewDataIndex >= 0 && dataItem.ky != "") {
          this.pmViewData[viewDataIndex].serviceType = dataItem.ky;

          this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'serviceType', dataItem.ky);
        }

        let changedRow = this.equipmentRouteViewData.filter((eqData: any) => eqData.changeItemId == this.pmViewData[viewDataIndex].changeItemId);
        changedRow.forEach(headerItem => {
          const eqItem = this.equipmentRouteViewData_Filtered.find(eqItem => eqItem.changeItemId === headerItem.changeItemId); if (eqItem) {
            eqItem.serviceType = dataItem.ky
          }
        });
      }
      else if (this.popupOpenField == 'mwoNumber' && dataItem != null) {

        this.mwoValueChanged([dataItem], dataItem.mwoNumber, this.popUpOpenFieldChangeItemId);

      }
      else if (this.popupOpenField == 'frequencyIndicator') {
        let viewDataIndex = this.pmViewData.findIndex((x: PMBuild) => x.changeItemId == this.popUpOpenFieldChangeItemId);

        if (viewDataIndex >= 0 && dataItem.frequencyIndicator != "") {
          this.pmViewData[viewDataIndex].frequencyIndicator = dataItem.frequencyIndicator;

          this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'frequencyIndicator', dataItem.frequencyIndicator);
        }
      }
    }

    if (this.popupOpenField == 'minorServiceType') {
      let viewDataIndex = this.associationViewData.findIndex((x: any) => x.id == this.popUpOpenFieldChangeItemId);

      
      if (viewDataIndex >= 0) {
        this.associationViewData[viewDataIndex].serviceType = dataItem.srvt;
        this.associationViewData.filter((eqData: any) => eqData.changeItemId == this.associationViewData[viewDataIndex].changeItemId &&
          eqData.changeItemPmId == this.associationViewData[viewDataIndex].changeItemPmId &&
          eqData.acdAction === this.associationViewData[viewDataIndex].acdAction &&
          eqData.id < 0)
          .forEach(headerItem => {
          headerItem.serviceType = dataItem.srvt;
        });

        this.associationViewData_Filtered
          .filter((eqData: any) => eqData.changeItemId == this.associationViewData[viewDataIndex].changeItemId &&
            eqData.changeItemPmId == this.associationViewData[viewDataIndex].changeItemPmId &&
            eqData.acdAction === this.associationViewData[viewDataIndex].acdAction
            && eqData.id < 0)
          .forEach(headerItem => {
            headerItem.serviceType = dataItem.srvt;
          });

        //this.onAssociationValueChange(this.associationViewData[viewDataIndex], 'minorServiceType', dataItem.srvt);

        let filteredViewDataIndex = this.associationViewData_Filtered.findIndex((x: any) => x.id == this.popUpOpenFieldChangeItemId);
        if (viewDataIndex >= 0) {
          this.associationViewData_Filtered[filteredViewDataIndex] = JSON.parse(JSON.stringify(this.associationViewData[viewDataIndex]));
        }
      }
    }
    if (this.popupOpenField == 'equipTagNumber') {
      let viewDataIndex = this.equipmentRouteViewData.findIndex((x: any) => x.id == this.popUpOpenFieldChangeItemId);

      if (viewDataIndex >= 0) {
        this.equipmentRouteViewData[viewDataIndex].routeTag = dataItem.equipTag;

        this.onEquipmentRouteValueChange(this.equipmentRouteViewData[viewDataIndex], 'routeTag', dataItem.equipTag);

        let filteredViewDataIndex = this.equipmentRouteViewData_Filtered.findIndex((x: any) => x.id == this.popUpOpenFieldChangeItemId);
        if (viewDataIndex >= 0) {
          this.equipmentRouteViewData_Filtered[filteredViewDataIndex] = JSON.parse(JSON.stringify(this.equipmentRouteViewData[viewDataIndex]));
        }
      } else {
        let viewDataIndex = this.equipmentRouteViewData.findIndex((x: any) => x.localAddRoute == this.popUpOpenFieldChangeItemId);
        if (viewDataIndex >= 0) {
          this.equipmentRouteViewData[viewDataIndex].routeTag = dataItem.equipTag;

          this.onEquipmentRouteValueChange(this.equipmentRouteViewData[viewDataIndex], 'routeTag', dataItem.equipTag);

          let filteredViewDataIndex = this.equipmentRouteViewData_Filtered.findIndex((x: any) => x.localAddRoute == this.popUpOpenFieldChangeItemId);
          if (viewDataIndex >= 0) {
            this.equipmentRouteViewData_Filtered[filteredViewDataIndex] = JSON.parse(JSON.stringify(this.equipmentRouteViewData[viewDataIndex]));
          }
        }
      }
    }

    this.closeActionPopup(false);
  }

  mwoValueChanged(dataItem: any, dataSelected: any, changeitemid: any) {
    let viewDataIndex = this.pmViewData.findIndex((x: PMBuild) => x.changeItemId == changeitemid);
    let selectedValue = dataItem[0];
    if (selectedValue?.mwoNumber == 0) {
      selectedValue.mwoNumber = selectedValue.mctMwoNumber;
    }
    if (viewDataIndex >= 0 && dataItem.length > 0) {
      this.pmViewData[viewDataIndex].mwoNumber = selectedValue.mwoNumber.toString();
      this.pmViewData[viewDataIndex].mwoProblemDescription = selectedValue.mwoProblemDescription;
      this.pmViewData[viewDataIndex].equipTagNumber = selectedValue.equipTagNumber;
      this.pmViewData[viewDataIndex].planningCoordinatorCode = selectedValue.planningcoordinatorcode;
      this.pmViewData[viewDataIndex].maintenanceCoordinatorCode = selectedValue.maintcoordcode;
      this.pmViewData[viewDataIndex].performanceStandard = selectedValue.performanceStandard;

      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'mwoNumber', selectedValue.mwoNumber, false, false);
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'mwoProblemDescription', selectedValue.mwoProblemDescription);
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'equipTagNumber', selectedValue.equipTagNumber);
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'maintenanceCoordinatorCode', selectedValue.maintcoordcode);
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'planningCoordinatorCode', selectedValue.planningcoordinatorcode);
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'performanceStandard', selectedValue.performanceStandard);


      let changedRow = this.equipmentRouteViewData.filter((eqData: any) => eqData.changeItemPmId == this.pmViewData[viewDataIndex].id);
      changedRow.forEach(headerItem => {
        const eqItem = this.equipmentRouteViewData.find(eqItem => eqItem.changeItemId === headerItem.changeItemId);
        if (eqItem) {
          headerItem.mwo = selectedValue.mwoNumber.toString();
          headerItem.headerTag = selectedValue.equipTagNumber;
          headerItem.performanceStandard = selectedValue.performanceStandard;
          if (headerItem.headerRoute == 'Header') {
            headerItem.routeTag = selectedValue.equipTagNumber
          }
          // if(headerItem.headerRoute == ''){
          //   headerItem.headerRoute = 'Header';
          // }
        }
      });

      changedRow = this.associationViewData.filter((eqData: any) => eqData.changeItemPmId == this.pmViewData[viewDataIndex].id);
      changedRow.forEach(headerItem => {
        const eqItem = this.associationViewData.find(eqItem => eqItem.changeItemId === headerItem.changeItemId); if (eqItem) {
          if (eqItem) {
            headerItem.mwo = selectedValue.mwoNumber.toString();
            headerItem.equipTagNumber = selectedValue.equipTagNumber;
          }
        }
      });
      this.headerSelectionFilter();
    }
    else if (dataItem.length == 0) {
      this.pmViewData[viewDataIndex].mwoNumber = dataSelected?.toString();
      this.pmViewData[viewDataIndex].mwoProblemDescription = '';
      this.pmViewData[viewDataIndex].equipTagNumber = '';
      this.pmViewData[viewDataIndex].planningCoordinatorCode = 0;
      this.pmViewData[viewDataIndex].maintenanceCoordinatorCode = 0;
      this.pmViewData[viewDataIndex].performanceStandard = '';

      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'mwoNumber', dataSelected);
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'mwoProblemDescription', '');
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'equipTagNumber', '');
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'maintenanceCoordinatorCode', 0);
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'planningCoordinatorCode', 0);
      this.onHeaderValueChange(this.pmViewData[viewDataIndex], 'performanceStandard', '');


      let changedRow = this.equipmentRouteViewData.filter((eqData: any) => eqData.changeItemPmId == this.pmViewData[viewDataIndex].id);
      changedRow.forEach(headerItem => {
        const eqItem = this.equipmentRouteViewData.find(eqItem => eqItem.changeItemId === headerItem.changeItemId); if (eqItem) {
          eqItem.mwo = '0';
          eqItem.headerTag = '';
          if(eqItem.headerRoute == 'Header') {
          eqItem.routeTag = ''
          }
        }
      });
      changedRow = this.associationViewData.filter((eqData: any) => eqData.changeItemPmId == this.pmViewData[viewDataIndex].id);
      changedRow.forEach(headerItem => {
        const eqItem = this.associationViewData.find(eqItem => eqItem.changeItemId === headerItem.changeItemId); if (eqItem) {
          eqItem.mwo = "0";
          eqItem.equipTagNumber = '';
        }
      });
            this.headerSelectionFilter();
    }
  }

  serviceTypeChange(dataItem: any) {
    this.equipmentRouteViewData_Filtered.filter((eqData: any) => eqData.changeItemPmId == dataItem.id).forEach(headerItem => {
      headerItem.serviceType = dataItem.serviceType;
      let viewIndex = this.equipmentRouteViewData.findIndex((x: any) => headerItem.id == x.id);
      if (viewIndex > -1) {
        this.equipmentRouteViewData[viewIndex] = JSON.parse(JSON.stringify(headerItem));
      }
    });
    this.associationViewData_Filtered.filter((eqData: any) => eqData.changeItemPmId == dataItem.id).forEach(headerItem => {
      headerItem.majorServiceType = dataItem.serviceType;
      let viewIndex = this.associationViewData.findIndex((x: any) => headerItem.id == x.id);
      if (viewIndex > -1) {
        this.associationViewData[viewIndex] = JSON.parse(JSON.stringify(headerItem));
      }
    });
    let viewDataIndex = this.pmViewData.findIndex((x: PMBuild) => x.changeItemId == dataItem.changeItemId);
    if (viewDataIndex > -1 && dataItem.serviceType.trim().toLowerCase().startsWith('unschd')) {
      this.pmViewData[viewDataIndex].disabledItems = true;
    } else {
      this.pmViewData[viewDataIndex].disabledItems = false;

    }

  }


  closeActionPopup(status: boolean) {
    this.popUpOpenFieldChangeItemId = 0;
    this.popupTitle = "";
    this.popupDataList = { data: [], total: 0 };
    this.popupShow = status;
    this.showFileUploadPopup = false;
    this.popupHeight = 400;
    this.popupWidth = 600;
    this.fieldValidationInput = [];
    this.lastImportedType = "";
    this.skip = 0;
    this.searchText = '';
    this.minorserviceequipTag = '';
    this.minorserviceserviceType = ''
  }

  clickImport(gridName: string) {
    let title = gridName == "Header" ? "PM schedule" : "route";
    this.lastImportedType = gridName;
    this.popupTitle = `Import new ${title} changes to change request #` + this.crNo;
    this.popupHeight = 250;
    this.popupWidth = 500;
    this.fieldValidationInput = gridName == "Header" ? this.headerFieldValidationInput : this.eqRouteValidationInput;
    this.showFileUploadPopup = true;
  }

  imported(data: ImportData) {
    if (data.validationMsgs.length > 0) {
      this.commonService.showNotificationMessage(data.validationMsgs.join("<br>"), "error", "center");
    } else {


      data.data.map((x: any, index: number) => {
        x.rowNumber = index;

        if (x.lastCompDate) {
          let parts: string[] = [];
          if (typeof x.lastCompDate === 'string') {
            parts = x.lastCompDate.split('/');
          } else if (typeof x.lastCompDate === 'object' && x.lastCompDate instanceof Date) {
            // Format the Date object to dd/mm/yyyy string, then split
            const day = String(x.lastCompDate.getDate()).padStart(2, '0');
            const month = String(x.lastCompDate.getMonth() + 1).padStart(2, '0');
            const year = x.lastCompDate.getFullYear();
            parts = [`${day}`, `${month}`, `${year}`];
          }
          if (parts.length === 3) {
            x.lastCompDate = `${parts[2]}-${parts[1]}-${parts[0]}T00:00:00`;
          }
        } else {
          x.lastCompDate = null;
        }

        // Convert schedTickler from dd/mm/yyyy to yyyy-mm-ddT00:00:00
        if (x.schedTickler) {
          let parts: string[] = [];
          if (typeof x.schedTickler === 'string') {
            parts = x.schedTickler.split('/');
          } else if (typeof x.schedTickler === 'object' && x.schedTickler instanceof Date) {
            const day = String(x.schedTickler.getDate()).padStart(2, '0');
            const month = String(x.schedTickler.getMonth() + 1).padStart(2, '0');
            const year = x.schedTickler.getFullYear();
            parts = [`${day}`, `${month}`, `${year}`];
          }
          if (parts.length === 3) {
            x.schedTickler = `${parts[2]}-${parts[1]}-${parts[0]}T00:00:00`;
          }
        } else {
          x.schedTickler = null;
        }
        x.frequencyIndicator = x.frequencyIndicator === '' ? ' ' : x.frequencyIndicator;
        x.multiFlag = x.multiFlag === '' ? ' ' : x.multiFlag;
        x.lastCompDateEntered = x.lastCompDate ? x.lastCompDate : null;        
      });
      this.importHeader_EquipmentRoute(data?.data ?? [], this.lastImportedType);
    }

    this.closeActionPopup(false);
  }

  importHeader_EquipmentRoute(payload: any[], gridName: string) {
    let datetransform = new DateTransformPipe();
    payload.forEach((x: any) => {
      if (!isNaN(x.mwoNumber)) {
        x.mwoNumber = x.mwoNumber?.toString();
      }
      if (!isNaN(x.mwo)) {
        x.mwo = x.mwo?.toString();
      }
    })
    this.pmService.importPMHeader_EquipmentRoute(this.crNo, payload, this.lastImportedType == "Header").subscribe({
      next: (response: any) => {
        if (response) {
          if (response.validationMessage?.length > 0) {
            let errorCountStatement = response.validationMessage.length > 5 ? `There are ${response.validationMessage.length} error fields and the first 5 are:` : `There are ${response.validationMessage.length} error fields:`
            let errorMessageList = response.validationMessage.length > 5 ? response.validationMessage.splice(0, 5) : response.validationMessage;
            errorMessageList.splice(0, 0, errorCountStatement);
            this.commonService.showNotificationMessage(errorMessageList.join("<br>"), "error", "center");
          } else {
            if (gridName == "Header") {
              if (response?.headerResponse?.length > 0) {                
                response.headerResponse.forEach((x: any) => {

                  let viewDataIndex = this.pmViewData.findIndex((y: any) => x.id == y.id && x.emdmKey == y.emdmKey);
                  if(x.schedTicklerEntered == undefined){
                    x.schedTicklerEntered = x.schedTickler;
                  }
                  if (x.lastCompDateEntered == undefined) {
                    x.lastCompDateEntered = x.lastCompDate;
                  }
                  if (x.lastCompDate != null && x.lastCompDate != '') {
                    if (typeof x.lastCompDate === 'string') {
                      x.lastCompDate = new Date(x.lastCompDate);                      
                    }
                    //x.lastCompDate = datetransform.transform(x.lastCompDate, "dd/MM/yyyy", true);
                    x.lastCompDateEntered = datetransform.transform(x.lastCompDate, "dd/MM/yyyy", true);
                  }
                  if (x.schedTickler != null && x.schedTickler != '') {
                    if (typeof x.schedTickler === 'string') {
                      x.schedTickler = new Date(x.schedTickler);                     
                    }
                    //x.schedTickler = datetransform.transform(x.schedTickler, "dd/MM/yyyy", true);
                    x.schedTicklerEntered = datetransform.transform(x.schedTickler, "dd/MM/yyyy", true);
                  }
                  if (viewDataIndex >= 0) {
                    this.pmViewData[viewDataIndex] = JSON.parse(JSON.stringify(x));
                    this.pmViewData[viewDataIndex].fieldChangedList = [];
                    if (x.modifiedFields != null && x.modifiedFields != '') {
                      this.pmViewData[viewDataIndex].fieldChangedList = x.modifiedFields.split(";");
                    }
                    if (x?.modifiedFields?.includes('mwoNumber')) {
                      this.mwoNumberChange(x);
                    }
                    if (x?.modifiedFields?.includes('serviceType')) {
                      this.serviceTypeChange(x);
                    }
                    if (x.modifiedFields?.includes('LastCompDate')) {
                      this.pmViewData[viewDataIndex].lastCompDate = new Date(x.lastCompDate); 
                      x.lastCompDate = typeof x.lastCompDate === 'string' ? x.lastCompDate : datetransform.transform(x.lastCompDate, "dd/MM/yyyy", true);
                      this.pmViewData[viewDataIndex].lastCompDateEntered = x.lastCompDate;                      
                      this.pmViewData[viewDataIndex].fieldChangedList.push('lastCompDate');                  
                    }
                    if (x?.modifiedFields?.includes('schedTickler')) {
                      this.pmViewData[viewDataIndex].schedTickler = new Date(x.schedTickler);
                      x.schedTickler = typeof x.schedTickler === 'string' ? x.schedTickler:  datetransform.transform(x.schedTickler, "dd/MM/yyyy", true);
                      this.pmViewData[viewDataIndex].schedTicklerEntered = x.schedTickler;
                      this.pmViewData[viewDataIndex].fieldChangedList.push('schedTickler');  
                    }
                    if (x?.modifiedFields?.includes('serviceDays')) {
                      let changedRow = this.associationViewData.filter((eqData: any) => eqData.changeItemPmId == x.id);
                      changedRow.forEach(headerItem => {
                        const eqItem = this.associationViewData.find(eqItem => eqItem.changeItemId === headerItem.changeItemId);
                        if (eqItem) {
                          headerItem.serviceDays = x.serviceDays;
                        }
                      });
                      if (x.modifiedFields?.length > 0 && x.acdAction == 'Delete') {
                        x.acdAction = 'Change';
                        x.acdId = this.setACDID('Change');
                      }

                      this.headerSelectionFilter();

                    }

                    if (viewDataIndex > -1 && x.serviceType.trim().toLowerCase().startsWith('unschd')) {
                      this.pmViewData[viewDataIndex].disabledItems = true;
                    } else {
                      this.pmViewData[viewDataIndex].disabledItems = false;
                    }
                  }
                });
              }
            }
            else {
              if (response?.eqRouteResponse?.length > 0) {
                response.eqRouteResponse?.forEach((x: any, rowIndex: any) => {
                  let viewDataIndex = this.equipmentRouteViewData.findIndex((y: any) => x.id == y.id && x.emdmKey == y.emdmKey);

                  if (viewDataIndex >= 0) {
                    this.equipmentRouteViewData[viewDataIndex] = JSON.parse(JSON.stringify(x));
                    this.equipmentRouteViewData[viewDataIndex].fieldChangedList = [];
                    if (x.modifiedFields != null && x.modifiedFields != '') {
                      this.equipmentRouteViewData[viewDataIndex].fieldChangedList = x.modifiedFields.split(";");
                    }

                    let filterViewDataIndex = this.equipmentRouteViewData_Filtered.findIndex((y: any) => x.id == y.id && x.emdmKey == y.emdmKey);
                    if (filterViewDataIndex >= 0) {
                      this.equipmentRouteViewData_Filtered[filterViewDataIndex] = JSON.parse(JSON.stringify(x));
                      this.equipmentRouteViewData_Filtered[filterViewDataIndex].fieldChangedList = [];
                      if (x.modifiedFields != null && x.modifiedFields != '') {
                        this.equipmentRouteViewData_Filtered[filterViewDataIndex].fieldChangedList = x.modifiedFields.split(";");
                      }
                    }
                  }
                  if (x.id == 0) {
                    this.addImportEquipmentRoute(response.eqRouteResponse[rowIndex], rowIndex);
                  }
                });
              }
            }
          }
        }
      },
      error: () => {

      }
    })
  }

  backBTNClicked() {
    this.stepNavigateTo.emit('Search');
  }

  //#region Equipment Route Grid

  actionedList: any[] = [];

  equipmentRouteActionApply() {
    this.actionedList = [];
    let selectedEquipmentRoutes = this.equipmentRouteViewData.filter((x: any) => this.equipmentSelectedIds.has(x.id));
    if (selectedEquipmentRoutes.length > 0) {
      if (this.equipmentRouteActionName == "No change") {
        selectedEquipmentRoutes.filter((x: any) => x.acdAction == "Delete").forEach((x: any) => {
          this.actionedList.push({ oldActionName: x.acdAction, id: x.id });
          x.acdAction = "No change";
          x.acdId = this.commonService.setACDID("No change");
        });
        selectedEquipmentRoutes.filter((x: any) => x.acdAction?.toLocaleLowerCase() == "change").forEach((x: any) => {
          this.actionedList.push({ oldActionName: x.acdAction, id: x.id });
          x.acdAction = "No change";
          x.acdId = this.commonService.setACDID("No change");
          x.fieldChangedList = [];
          x.modifiedFields = '';
          x.headerRoute = x.headerRoute == 'Header' ? 'Route' : 'Header';
        });
        this.equipmentRouteViewData_Filtered = JSON.parse(JSON.stringify(this.equipmentRouteViewData));
        this.headerRouteTagFilter();

        this.equipmentRouteDelete(selectedEquipmentRoutes);
      }
      else if (this.equipmentRouteActionName == "Add") {
        this.equipmentRouteViewData_Filtered = JSON.parse(JSON.stringify(this.equipmentRouteViewData));
        let newDataList = JSON.parse(JSON.stringify(this.equipmentRouteViewData));

        newDataList.forEach((x: any, index: number) => {
          if (this.equipmentSelectedIds.has(x.id)) {
            let newData = JSON.parse(JSON.stringify(x));
            this.addEquipmentRoute(newData, index, --this.loacallyAddNewId);
            this.actionedList.push({ oldActionName: 'Add', id: this.loacallyAddNewId });
          }
        });

        this.headerRouteTagFilter();
      }
      else if (this.equipmentRouteActionName == "Delete") {
        selectedEquipmentRoutes.filter((x: any) => x.acdAction.toLocaleLowerCase() == "no change" || x.acdAction.toLocaleLowerCase() == "change").forEach((x: any) => {
          this.actionedList.push({ oldActionName: x.acdAction, id: x.id });
          x.acdAction = "Delete";
          x.acdId = this.commonService.setACDID("Delete");

          let ogDataItem = this.equipmentRouteOGData.find((ogdata: any) => ogdata.changeItemId == x.changeItemId);
          if (ogDataItem) {
            x.headerRoute = ogDataItem.headerRoute;
          }
        });

        this.equipmentRouteViewData_Filtered = JSON.parse(JSON.stringify(this.equipmentRouteViewData));
        this.headerRouteTagFilter();

        this.equipmentRouteDelete(selectedEquipmentRoutes);
      }

      this.lastEquipmentRouteActionName = this.equipmentRouteActionName;
    }

    this.headerSelectionFilter();

    this.equipmentSelectedIds.clear();
    this.actionApplied = this.actionedList.length > 0; // to show undo button after action applies for selected ids
  }

  headerSelectionFilter() {
    if (this.headerSelectedIds.size > 0) {
      let selectedDatas = JSON.parse(JSON.stringify(this.pmViewData.filter((x: PMBuild) => this.headerSelectedIds.has(x.changeItemId ?? 0))));

      if (selectedDatas.length > 0) {
        this.equipmentRouteViewData_Filtered = JSON.parse(JSON.stringify(this.equipmentRouteViewData.filter((eqData: any) => selectedDatas.some((selected: any) => eqData.changeItemPmId == selected.id))));
        this.associationViewData_Filtered = JSON.parse(JSON.stringify(this.associationViewData.filter((associateData: any) => selectedDatas.some((selected: any) => associateData.changeItemPmId == selected.id))));
      }
      else {
        this.equipmentRouteViewData_Filtered = JSON.parse(JSON.stringify(this.equipmentRouteViewData));
        this.associationViewData_Filtered = JSON.parse(JSON.stringify(this.associationViewData));
      }
    } else {
      this.equipmentRouteViewData_Filtered = JSON.parse(JSON.stringify(this.equipmentRouteViewData));
      this.associationViewData_Filtered = JSON.parse(JSON.stringify(this.associationViewData));
    }
    
  }

  equipmentRouteDelete(selectedEquipmentRoutes: any[]) {
    //LOCAL DELETE
    this.equipmentRouteViewData_Filtered = this.equipmentRouteViewData_Filtered.filter((x: any) => !(x.acdAction == "Add" && x.isLocallyCreated && this.equipmentSelectedIds.has(x.id)));
    this.equipmentRouteViewData = this.equipmentRouteViewData.filter((x: any) => !(x.acdAction == "Add" && x.isLocallyCreated && this.equipmentSelectedIds.has(x.id)));

    //API DELETE
    let selectedAddIds = selectedEquipmentRoutes.filter((x: any) => x.acdAction == "Add" && !x.isLocallyCreated)
      .map((x: any) => x.id.toString());

    if (selectedAddIds.length > 0) {
      this.deleteEquipmentRoutes_Associations(selectedAddIds);
    }
  }

  public rowCallback = (context: RowClassArgs) => {
    if (context.dataItem.isParentIndexIsOdd % 2 == 0) {
      return { even: true };
    } else {
      return { odd: true };
    }
  };

  undoActionApplied() {
    //TODO undo action applied for equipment route

    if (this.actionedList.length > 0) {
      if (this.lastEquipmentRouteActionName == "Add") {
        this.equipmentRouteViewData_Filtered = this.equipmentRouteViewData_Filtered.filter((x: any) => !this.actionedList.some((y: any) => x.id == y.id));
        this.equipmentRouteViewData = this.equipmentRouteViewData.filter((x: any) => !this.actionedList.some((y: any) => x.id == y.id));
      }
      else {
        this.equipmentRouteViewData.filter((x: any) => this.actionedList.some((y: any) => x.id == y.id)).forEach((x: any) => {
          let undoStateData = this.actionedList.find((y: any) => x.id == y.id);
          if (undoStateData != undefined) {
            x.acdAction = undoStateData.oldActionName;
            x.acdId = this.commonService.setACDID(undoStateData.oldActionName);
          }
        });

        this.equipmentRouteViewData_Filtered = JSON.parse(JSON.stringify(this.equipmentRouteViewData));
        this.headerRouteTagFilter();
        this.headerSelectionFilter();
      }
    }

    this.actionedList = [];
    this.actionApplied = false; //after undo hiding undo button
    this.commonService.showNotificationMessage("ACD Action changes in Routes undone", "success", "center");
  }

  headerRouteTagSearchPopUpOpened: boolean = false;
  headerRouteTagSearchPopUpType: string = "";
  headerRouteTagSearchPopUpTitle: string = "";
  headerRouteTagSearchText: string = "";
  headerTagSearchText: Set<string> = new Set();
  routeTagSearchText: Set<string> = new Set();

  headerRouteTagSearchPopUpOpen(tagType: string) {
    this.headerRouteTagSearchPopUpType = tagType;
    this.headerRouteTagSearchPopUpTitle = tagType + " Tag Filter";
    this.headerRouteTagSearchPopUpOpened = true;
  }

  headerRouteTagSearch() {
    this.headerRouteTagSearchPopUpOpened = false;
    this.headerRouteTagSearchPopUpTitle = '';

    if (this.headerRouteTagSearchText != '') {
      this.headerRouteTagSearchText = this.headerRouteTagSearchText.replace(/\n/g, ',');
      this.headerRouteTagSearchText.split(",").forEach((searchText: string) => {
        if (this.headerRouteTagSearchPopUpType == "Header") {
          this.headerTagSearchText.add(searchText);
        }

        else if (this.headerRouteTagSearchPopUpType == "Route") {
          this.routeTagSearchText.add(searchText);
        }
      });
    }

    this.headerRouteTagSearchText = '';
    this.headerRouteTagFilter();
  }

  headerRouteTagFilter() {
    if (this.headerTagSearchText.size > 0 && this.routeTagSearchText.size > 0) {
      this.equipmentRouteViewData_Filtered = this.equipmentRouteViewData.filter((x: any) => this.headerTagSearchText.has(x.headerTag ?? "") && this.routeTagSearchText.has(x.routeTag ?? ""));
    }
    else if (this.headerTagSearchText.size > 0) {
      this.equipmentRouteViewData_Filtered = this.equipmentRouteViewData.filter((x: any) => this.headerTagSearchText.has(x.headerTag ?? ""));
    }
    else if (this.routeTagSearchText.size > 0) {
      this.equipmentRouteViewData_Filtered = this.equipmentRouteViewData.filter((x: any) => this.routeTagSearchText.has(x.routeTag ?? ""));
    } else {
      this.equipmentRouteViewData_Filtered = this.equipmentRouteViewData;
    }
  }

  clearHeaderRouteTagFilter(tagType: string) {
    if (tagType == "Header") {
      this.headerTagSearchText.clear();
    } else if (tagType == "Route") {
      this.routeTagSearchText.clear();
    }

    this.headerRouteTagFilter();
  }

  addImportEquipmentRoute(dataItem: any, index: number, newId: number = 0) {
    if (newId == 0) {
      newId = --this.loacallyAddNewId;
    }
    let newDataItem = JSON.parse(JSON.stringify(dataItem));
    newDataItem.id = newId;
    newDataItem.bomId = newId;
    newDataItem.localAddRoute = this.localAddRoute++;
    newDataItem.acdAction = "Add";
    newDataItem.acdId = this.commonService.setACDID("Add");
    newDataItem.routeTag = dataItem.routeTag;
    newDataItem.isLocallyCreated = true;
    newDataItem.changeItemPmId = dataItem.changeItemPmId;
    this.equipmentRouteViewData.splice(index + 1, 0, JSON.parse(JSON.stringify(newDataItem)));
    this.equipmentRouteViewData_Filtered.splice(index + 1, 0, JSON.parse(JSON.stringify(newDataItem)));
  }

  addEquipmentRoute(dataItem: any, index: number, newId: number = 0) {
    if (newId == 0) {
      newId = --this.loacallyAddNewId;
    }
    let newDataItem = JSON.parse(JSON.stringify(dataItem));
    let viewDataIndex = this.equipmentRouteViewData.findIndex((x: any) => x.id == dataItem.id);
    newDataItem.id = newId;
    newDataItem.bomId = newId;
    newDataItem.localAddRoute = this.localAddRoute++;
    newDataItem.acdAction = "Add";
    newDataItem.acdId = this.commonService.setACDID("Add");
    newDataItem.routeTag = "";
    newDataItem.isLocallyCreated = true;
    newDataItem.changeItemPmId = dataItem.changeItemPmId;
    this.equipmentRouteViewData.splice(viewDataIndex + 1, 0, JSON.parse(JSON.stringify(newDataItem)));
    this.equipmentRouteViewData_Filtered.splice(index + 1, 0, JSON.parse(JSON.stringify(newDataItem)));
  }

  deleteEquipmentRoute(dataItem: any, index: number) {
    let viewDataIndex = this.equipmentRouteViewData.findIndex((x: any) => x.id == dataItem.id);

    if (viewDataIndex >= 0) {
      if (dataItem.acdAction == "Add" && dataItem.isLocallyCreated) {
        this.equipmentRouteViewData_Filtered.splice(index, 1);
        this.equipmentRouteViewData.splice(viewDataIndex, 1);
      }
      else if (dataItem.acdAction == "Add" && !dataItem.isLocallyCreated) {
        this.deleteEquipmentRoutes_Associations([dataItem.id.toString()]);
      }
      else {
        dataItem.acdAction = "Delete";
        dataItem.acdId = this.commonService.setACDID("Delete");
        dataItem.fieldChangedList = null;
        let ogDataItem = this.equipmentRouteOGData.find((x: any) => x.changeItemId == dataItem.changeItemId);

        if (ogDataItem) {
          dataItem.headerRoute = ogDataItem.headerRoute;
        }

        this.equipmentRouteViewData[viewDataIndex].acdId = this.commonService.setACDID("Delete");
        this.equipmentRouteViewData[viewDataIndex].acdAction = "Delete";
      }
    }
  }

  undoEquipmentRoute(dataItem: any, index: number) {
    let ogDataItem = this.equipmentRouteOGData.find((x: any) => x.changeItemId == dataItem.changeItemId);

    if (ogDataItem) {
      dataItem.headerRoute = ogDataItem.headerRoute;
      dataItem.acdAction = 'No change';
      dataItem.acdId = this.setACDID('No change');

    }

    let viewDataIndex = this.equipmentRouteViewData.findIndex((x: any) => x.id == dataItem.id);

    if (viewDataIndex >= 0) {
      this.equipmentRouteViewData[viewDataIndex] = JSON.parse(JSON.stringify(dataItem));
      this.equipmentRouteViewData_Filtered[index] = JSON.parse(JSON.stringify(dataItem));
    }
  }

  onEquipmentRouteValueChange(dataItem: any, field: string, event: any) {
    dataItem.fieldChangedList ??= [];
    let ogData = this.equipmentRouteOGData.find((x: any) => dataItem.changeItemId == x.changeItemId) as { [key: string]: any };;
    if (dataItem.acdAction != 'Add') {
      if (event != null && ogData[field]?.toString() !== event?.toString()) {
        if (dataItem.fieldChangedList.find((x: string) => x == field) == undefined) {
          dataItem.fieldChangedList.push(field);
        }
        else {
          let index = dataItem.fieldChangedList.findIndex((x: string) => x == field);
          if (index > -1) {
            dataItem.fieldChangedList.splice(index, 1);
          }
        }
      }
      else {
        let index = dataItem.fieldChangedList.findIndex((x: string) => x == field);
        if (index > -1) {
          dataItem.fieldChangedList.splice(index, 1);
        }
      }

      dataItem.acdAction = dataItem.fieldChangedList == 0 ? 'No change' : 'Change';
      dataItem.acdId = this.setACDID(dataItem.acdAction);
      if (dataItem.acdAction.toLocaleLowerCase() == 'no change') {
        dataItem.fieldChangedList = [];
        dataItem.modifiedFields = '';
      }
    }
    let viewIndex = this.equipmentRouteViewData.findIndex((x: any) => x.id == dataItem.id);
    if (viewIndex > -1) {
      this.equipmentRouteViewData[viewIndex][field] = dataItem[field];
      this.equipmentRouteViewData[viewIndex].acdAction = dataItem.acdAction;
      this.equipmentRouteViewData[viewIndex].acdId = dataItem.acdId;
      this.equipmentRouteViewData[viewIndex].fieldChangedList = dataItem.fieldChangedList;
      this.equipmentRouteViewData[viewIndex].modifiedFields = dataItem.modifiedFields;
    }
  }

  onAssociationValueChange(dataItem: any, field: string, event: any) {
    dataItem.fieldChangedList ??= [];

    let ogData = this.associationOGData.find((x: any) => dataItem.changeItemId == x.changeItemId) as { [key: string]: any };
    if (dataItem.acdAction != 'Add') {
      if (event != null && ogData[field]?.toString() !== event?.toString()) {
        if (dataItem.fieldChangedList.find((x: string) => x == field) == undefined) {
          dataItem.fieldChangedList.push(field);
        }
      }
      else {
        let index = dataItem.fieldChangedList.findIndex((x: string) => x == field);
        if (index > -1) {
          dataItem.fieldChangedList.splice(index, 1);
        }
      }

      dataItem.acdAction = dataItem.fieldChangedList == 0 ? 'No change' : 'Change';
      dataItem.acdId = this.setACDID(dataItem.acdAction);
    }
    let viewIndex = this.associationViewData.findIndex((x: any) => dataItem.id == x.id && dataItem.id > 0);
    if (viewIndex > -1) {
      this.associationViewData[viewIndex] = JSON.parse(JSON.stringify(dataItem));
    } else {
      let viewLocalIndex = this.associationViewData.findIndex((x: any) => dataItem.changeItemId == x.changeItemId && dataItem.id == x.id);
      if (viewLocalIndex > -1) {
        this.associationViewData[viewLocalIndex] = JSON.parse(JSON.stringify(dataItem));
      }
    }
  }

  deleteEquipmentRoutes_Associations(ids: any[], isEquipmentRouteDeleted: boolean = true) {
    let payload = {
      ids: ids.join(","),
      isEquipmentRouteDeleted: isEquipmentRouteDeleted
    };

    this.pmService.deleteEquipmentRouteAssociation(payload).subscribe({
      next: (response: any) => {
        if (response) {
          this.commonService.showNotificationMessage(response, 'success', 'center');

          let routeIds = ids.map((id: any) => parseInt(id));

          if (routeIds.length > 0) {
            if (isEquipmentRouteDeleted) {
              this.equipmentRouteViewData_Filtered = this.equipmentRouteViewData_Filtered.filter((x: any) => !routeIds.includes(x.id));
              this.equipmentRouteViewData = this.equipmentRouteViewData.filter((x: any) => !routeIds.includes(x.id));
            } else {
              this.associationViewData_Filtered = this.associationViewData_Filtered.filter((x: any) => !routeIds.includes(x.id));
              this.associationViewData = this.associationViewData.filter((x: any) => !routeIds.includes(x.id));
            }
          }
        }
      },
      error: () => {

      }
    })

  }

  //#endregion Equipment Route Grid

  //#region  association
  addAssociation() {
    if (this.headerSelectedIds.size > 0) {
      let payload = this.pmViewData.filter((x: any) => this.headerSelectedIds.has(x.changeItemId));
      // let mctReferenceNo = 'MCTMWO-'+this.crNo+'-';
      // payload?.forEach((x:any) => {
      //   if(isNaN(x.mwoNumber)){
      //   if(x.mwoNumber.startsWith(mctReferenceNo) ){
      //     x.mctMwo_Number = x.mwoNumber;
      //     x.mctMwoNumber = Number(x.mwoNumber.substring(mctReferenceNo.length));
      //     x.mwoNumber = 0;     
      //   }}
      // });
      if (payload.length > 0) {
        this.pmService.addAssociationRow(this.crNo, payload).subscribe({
          next: (response: any) => {
            if (response?.length > 0) {

              response = response.map((x: any) => {
                x.fieldChangedList = [];
                x.isView = true;
                x.isLocallyCreated = false;
                if (x.modifiedFields != null && x.modifiedFields != '') {
                  x.fieldChangedList = x.modifiedFields.split(";");
                }
               
                return x;
              });             
              this.associationOGData = [...this.associationOGData, ...response.filter((x: any) => !x.isStaging)];
              this.associationViewData = [...this.associationViewData, ...response.filter((x: any) => x.isStaging)];
              this.associationViewData = this.associationViewData.map((x: any) => {
                if (x.mwo == 0 && x.mctMwo_Number != null) {
                  x.mwo = x.mctMwo_Number;
                }
                return x;
              });
              this.associationViewData_Filtered = JSON.parse(JSON.stringify(this.associationViewData));
              this.headerSelectionFilter();
            }
          },
          error: () => {
          }
        });
      }
    }
  }

  addAssociationRow(dataItem: any, index: number) {
    this.parentAssocationAction = index == 0 ? dataItem.acdAction : this.parentAssocationAction;
    let viewDataIndex = this.associationViewData.findIndex((x: any) => x.id == dataItem.id);
    let newDataItem = JSON.parse(JSON.stringify(dataItem));

    newDataItem.id = --this.loacallyAddNewId;
    newDataItem.isLocallyCreated = true;
    newDataItem.acdAction = "Add";
    newDataItem.acdId = this.commonService.setACDID("Add");

    if (viewDataIndex >= 0) {
      this.associationViewData.splice(viewDataIndex + 1, 0, newDataItem);
    }

    this.associationViewData_Filtered.splice(index + 1, 0, newDataItem);
  }

  deleteAssociationRow(dataItem: any, index: number) {
    let viewDataIndex = this.associationViewData.findIndex((x: any) => x.id == dataItem.id);
    if (viewDataIndex >= 0) {
      if (dataItem.acdAction == "Add" && dataItem.isLocallyCreated) {
        this.associationViewData.splice(viewDataIndex, 1);
        this.associationViewData_Filtered.splice(index, 1);
      } else if (dataItem.acdAction == "Add" && !dataItem.isLocallyCreated) {
        this.deleteEquipmentRoutes_Associations([dataItem.id], false);
      } else {
        dataItem.acdId = this.commonService.setACDID("Delete");
        dataItem.acdAction = "Delete";

        this.associationViewData[viewDataIndex].acdId = this.commonService.setACDID("Delete");
        this.associationViewData[viewDataIndex].acdAction = "Delete";
      }
    }
  }

  undoAssociationRow(dataItem: any, index: number) {
    let ogDataItem = this.associationOGData.find((x: any) => x.changeItemId == dataItem.changeItemId);

    if (ogDataItem) {
      dataItem.acdAction = 'No change';
      dataItem.acdId = this.setACDID('No change');
    }

    let viewDataIndex = this.associationViewData.findIndex((x: any) => x.id == dataItem.id);

    if (viewDataIndex >= 0) {
      this.associationViewData[viewDataIndex] = JSON.parse(JSON.stringify(dataItem));
      this.associationViewData_Filtered[index] = JSON.parse(JSON.stringify(dataItem));
    }
  }
  //#endregion association
}
